export default __webpack_public_path__ + "static/btn-neon-big-d2d6d4215954ea33af392475afb48e1e.png";